/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".timeline-layer-add[_ngcontent-%COMP%]{position:relative;display:inline-block;line-height:36px;padding:0 12px 0 42px;margin:0 auto;border:none;border-radius:3px;background:rgba(0,0,0,.2);color:#fff;font-size:14px}.timeline-layer-add[_ngcontent-%COMP%]:hover{background-color:rgba(0,0,0,.25)}.timeline-layer-add[_ngcontent-%COMP%]:active{background-color:rgba(0,0,0,.3)}.timeline-layer-add__icon[_ngcontent-%COMP%]{position:absolute;top:50%;left:10px;margin-top:-12px;font-size:24px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline-layer-add/timeline-layer-add.component.styl.shim.ngstyle.js.pre-build-optimizer.js